import React from "react";
import Popover from "@mui/material/Popover";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import Face from "./Face";
import { filterCharacters } from "./tracksModel";

/** "Move To" / "Merge Into" list under the selection bar's button: search, New Character, every character */
export default function MoveToMenu({ open, anchorEl, title, items, current, showNew, base, onPick, onNew, onClose, t }) {
  const [q, setQ] = React.useState("");
  React.useEffect(() => {
    if (!open) setQ("");
  }, [open]);
  const list = filterCharacters(items, q);
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{ paper: { className: "tk-pick" } }}
    >
      <div className="tk-pickHead">
        <div className="tk-overline">{title}</div>
        <TextField
          className="tk-filter"
          size="small"
          fullWidth
          autoFocus
          placeholder={t("Find a character")}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            },
            htmlInput: { "aria-label": t("Find a character") },
          }}
        />
      </div>
      {showNew && (
        <button type="button" className="tk-pickNew" onClick={onNew}>
          <span>{t("New Character")}</span>
          <PersonAddIcon />
        </button>
      )}
      <div className="tk-pickList">
        {list.map((c) => {
          const isCurrent = current.includes(c.char_id);
          const n = c.tracks_data.length;
          return (
            <button key={c.char_id} type="button" className="tk-pickItem" disabled={isCurrent} onClick={() => onPick(c.char_id)}>
              <Face base={base} track={c.rep_track_id} person className="tk-pickFace" />
              <span className="tk-pickText">
                <span className="tk-pickName">{c.char_name}</span>
                <span className="tk-pickMeta">
                  {c.char_actor ? c.char_actor + " · " : ""}
                  {n === 1 ? t("1 track") : t("{{count}} tracks", { count: n })}
                </span>
              </span>
              {isCurrent && <span className="tk-pickCurrent">{t("Current")}</span>}
            </button>
          );
        })}
        {!list.length && <div className="tk-pickEmpty">{t("No characters match.")}</div>}
      </div>
    </Popover>
  );
}
